var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hbp-container hbp-container-above" }, [
    _c("div", { staticClass: "announcement router-view" }, [
      _c("div", { staticClass: "announcement-breadcrumb" }, [
        _c(
          "div",
          {
            staticClass: "xui-breadcrumb",
            attrs: { "aria-label": "Breadcrumb", role: "navigation" }
          },
          [
            _c(
              "span",
              {
                staticClass: "xui-breadcrumb__item",
                attrs: { "aria-current": "page" }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "xui-breadcrumb__inner is-link",
                    attrs: { role: "link" }
                  },
                  [
                    _c("img", {
                      attrs: { src: require("../../../images/ancmt-icon.png") }
                    }),
                    _vm._v(" "),
                    _c("router-link", { attrs: { to: "/announcement" } }, [
                      _c("span", [_vm._v(" 公告新闻")])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("i", {
                  staticClass: "xui-breadcrumb__separator xui-icon-arrow-right"
                })
              ]
            ),
            _vm._v(" "),
            _vm._m(0)
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "announcement-panel" }, [
        _c("div", { staticClass: "announcement-detail" }, [
          _c("h3", { staticClass: "announcement-detail-title" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "announcement-detail-info" }, [
            _c("span", [_vm._v("发布日期：" + _vm._s(_vm.time))])
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "detail-html",
            domProps: { innerHTML: _vm._s(_vm.content) }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "xui-breadcrumb__item" }, [
      _c(
        "span",
        { staticClass: "xui-breadcrumb__inner", attrs: { role: "link" } },
        [_vm._v("公告详情")]
      ),
      _vm._v(" "),
      _c("i", { staticClass: "xui-breadcrumb__separator xui-icon-arrow-right" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d2237e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d2237e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/announcement/detail/AnnouncementDetail.vue
// module id = null
// module chunks = 